import { useEffect } from "react";

/**
 * SEO — updates document.title & primary meta tags per page.
 * Lightweight alternative to react-helmet.
 */
export default function SEO({ title, description, path }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} · DAS SIMAO AUTO`
      : "DAS SIMAO AUTO — Convoyage & VTC premium partout en France";
    document.title = fullTitle;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc =
      description ||
      "Convoyage de véhicules et service VTC premium. Livraison partout en France, chauffeur privé, mise à disposition — devis en ligne, validation manuelle, paiement sécurisé.";
    setMeta("description", desc);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", "DAS SIMAO AUTO", "property");
    setMeta(
      "og:url",
      typeof window !== "undefined"
        ? window.location.href
        : "https://dassimaoauto.fr",
      "property",
    );
    setMeta("og:image", "/assets/logo.png", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
  }, [title, description, path]);

  return null;
}
